import { render, staticRenderFns } from "./HomeShortcuts.vue?vue&type=template&id=156a36f6&scoped=true"
import script from "./HomeShortcuts.vue?vue&type=script&lang=js"
export * from "./HomeShortcuts.vue?vue&type=script&lang=js"
import style0 from "./HomeShortcuts.vue?vue&type=style&index=0&id=156a36f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a36f6",
  null
  
)

export default component.exports